import * as React from 'react'
import { useParams } from 'react-router-dom'
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'
import { IpAllowListEditor } from '@/modules/shared/components/ipAllowList/IpAllowListEditor'

const IpAccessPageContent = () => {
  const { companyId } = useParams<{ companyId: string }>()
  return (
    <div className="tw-flex-1 tw-overflow-y-auto tw-p-6">
      <IpAllowListEditor companyId={companyId!} />
    </div>
  )
}

export const IpAccessPage = withDefaultErrorBoundary(IpAccessPageContent)
